var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9615 7.5H9.03846C8.18879 7.5 7.5 8.18879 7.5 9.03846V15.9615C7.5 16.8112 8.18879 17.5 9.03846 17.5H15.9615C16.8112 17.5 17.5 16.8112 17.5 15.9615V9.03846C17.5 8.18879 16.8112 7.5 15.9615 7.5Z",
    stroke: "#8F9FA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.80769 12.5H4.03846C3.63044 12.5 3.23912 12.3379 2.9506 12.0494C2.66209 11.7609 2.5 11.3696 2.5 10.9615V4.03846C2.5 3.63044 2.66209 3.23912 2.9506 2.9506C3.23912 2.66209 3.63044 2.5 4.03846 2.5H10.9615C11.3696 2.5 11.7609 2.66209 12.0494 2.9506C12.3379 3.23912 12.5 3.63044 12.5 4.03846V4.80769",
    stroke: "#8F9FA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.923991131bd578560097429001d043c5.svg";
export { ForwardRef as ReactComponent };